import { AnonymousStudentErrorType } from "../../../interfaces/enumerations/error-type";
import { StudentAPIBaseError } from "./student-api-base-error";

export class StudentAPIUnknownError extends StudentAPIBaseError {
	constructor(cause: Error) {

		const message = cause && cause.message !== undefined
			? cause.message
			: AnonymousStudentErrorType.UNKNOWN_ERROR

		super(message, {cause});
		this.name = AnonymousStudentErrorType.UNKNOWN_ERROR;
	}
}
